/**
 * Parses a numeric credit field from credit summary / plan payloads.
 * @param {unknown} value
 * @returns {number|null}
 */
export function parseFiniteCreditNumber(value) {
  if (value === undefined || value === null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Remaining device-day balance: allocCredit - mubUsage (same as PAYG post-Stripe banner).
 * @param {unknown} allocCredit
 * @param {unknown} mubUsage
 * @returns {number|null} null when allocCredit is missing or invalid
 */
export function computeBalanceDeviceDays(allocCredit, mubUsage) {
  const alloc = parseFiniteCreditNumber(allocCredit);
  if (alloc === null) return null;
  const usage = parseFiniteCreditNumber(mubUsage) ?? 0;
  return alloc - usage;
}
